import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { parse } from "tldts";
import "../css/Navbar.css";
import Navbarlanding from "./Navbarlanding";
import "../css/LegalDocumentsPage.css";
import Footer from "./Footerlanding";

const FILE_BASE = "http://213.210.37.235:3000";

const LegalDocumentsPage = () => {
  const [legalDocs, setLegalDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [viewMode, setViewMode] = useState("grid");

  const [menuOpen, setMenuOpen] = useState(false);
  const [loginDropdownOpen, setLoginDropdownOpen] = useState(false);
  const [applyNowOpen, setApplyNowOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const [company, setCompany] = useState({
    name: "Your Company",
    logo: "",
    favicon: "",
    domain: "",
    subdomain: "",
    superAdminId: "",
  });

  const getDomainInfo = () => {
    const hostname = window.location.hostname;
    const parsed = parse(hostname);
    return {
      domain: parsed.domainWithoutSuffix || "",
      subdomain: parsed.subdomain || "",
    };
  };

  useEffect(() => {
    const loadCompany = async () => {
      try {
        const { domain } = getDomainInfo();
        const response = await axios.get("https://payyug.in/api/get-company", {
          params: { domain },
        });
        if (response.data) setCompany(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    loadCompany();
  }, []);

  useEffect(() => {
    if (company.superAdminId) {
      fetchLegalDocs(company.superAdminId);
    }
  }, [company.superAdminId]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") setSelectedDoc(null);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  useEffect(() => {
    document.body.style.overflow = selectedDoc ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedDoc]);

  const fetchLegalDocs = async (superAdminId) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://payyug.in/api/all-legalDocument`,
        { params: { superAdminId } }
      );

      const docs = Array.isArray(response.data.documents)
        ? response.data.documents
        : Array.isArray(response.data)
        ? response.data
        : [];

      setLegalDocs(docs);
    } catch (error) {
      console.error("Error fetching legal documents:", error);
    } finally {
      setLoading(false);
    }
  };

  const getFileUrl = (documentFile) => {
    if (!documentFile) return "";
    if (documentFile.startsWith("http")) return documentFile;
    return `${FILE_BASE}/${documentFile}`;
  };

  const getLogoUrl = (path) => {
    if (!path) return "";
    const cleanPath = path.startsWith("images/") ? path.slice(7) : path;
    return `https://payyug.in/${cleanPath}`;
  };

  const isPdf = (documentFile) => {
    if (!documentFile) return false;
    return documentFile.toLowerCase().endsWith(".pdf");
  };

  const isImage = (documentFile) => {
    if (!documentFile) return false;
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(documentFile);
  };

  const getFileIcon = (documentFile) => {
    if (isPdf(documentFile)) return "fa-file-pdf";
    if (isImage(documentFile)) return "fa-file-image";
    return "fa-file-alt";
  };

  const getIconClass = (documentFile) => {
    if (isPdf(documentFile)) return "pdf";
    if (isImage(documentFile)) return "img";
    return "txt";
  };

  const getCardTopClass = (documentFile) => {
    if (isPdf(documentFile)) return "legal-card-top legal-card-top-pdf";
    if (isImage(documentFile)) return "legal-card-top legal-card-top-img";
    return "legal-card-top legal-card-top-txt";
  };

  const handleCardClick = (doc) => {
    const fileUrl = getFileUrl(doc.documentFile);
    setSelectedDoc({
      url: fileUrl,
      name: doc.name,
      type: doc.documentType || "Document",
      isPdf: isPdf(doc.documentFile),
      isImage: isImage(doc.documentFile),
    });
  };

  const handleLinkClick = () => {
    if (window.innerWidth <= 960) {
      setMenuOpen(false);
      setLoginDropdownOpen(false);
      setApplyNowOpen(false);
    }
  };

  const uniqueCategories = [
    ...new Set(legalDocs.map((d) => d.documentType).filter(Boolean)),
  ].length;

  return (
    <div className="legal-page">

      {/* HEADER */}
    <Navbarlanding />

      {/* HERO */}
      <section className="legal-hero">
        <div className="legal-overlay">
          <div className="legal-hero-pill">
            <i className="fas fa-shield-alt"></i> LEGAL &amp; COMPLIANCE
          </div>
          <h1>Legal Documents</h1>
          <p>
            Access all our official policies, agreements, and compliance
            materials in one place — always up to date.
          </p>

          {/* STATS BAR */}
          {!loading && legalDocs.length > 0 && (
            <div className="legal-hero-stats">
              <div className="legal-hero-stat">
                <span className="legal-hero-stat-n">{legalDocs.length}</span>
                <span className="legal-hero-stat-l">Documents</span>
              </div>
              <div className="legal-hero-stat-divider" />
              <div className="legal-hero-stat">
                <span className="legal-hero-stat-n">
                  {uniqueCategories || "—"}
                </span>
                <span className="legal-hero-stat-l">Categories</span>
              </div>
              <div className="legal-hero-stat-divider" />
              <div className="legal-hero-stat">
                <span className="legal-hero-stat-n">2026</span>
                <span className="legal-hero-stat-l">Last Updated</span>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* DOCUMENTS SECTION */}
      <section className="legal-section">
        <div className="legal-container">

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader"></div>
              <p>Loading Documents...</p>
            </div>
          ) : legalDocs.length === 0 ? (
            <div className="empty-state">
              <i className="fas fa-folder-open"></i>
              <h2>No Documents Available</h2>
              <p>Legal documents will appear here once uploaded by admin.</p>
            </div>
          ) : (
            <>
              {/* TOGGLE ROW */}
              <div className="legal-view-toggle-row">
                <span className="legal-doc-count">
                  All Documents <em>({legalDocs.length})</em>
                </span>
                <div className="legal-toggle">
                  <button
                    className={`legal-toggle-btn ${viewMode === "grid" ? "active" : ""}`}
                    onClick={() => setViewMode("grid")}
                  >
                    <i className="fas fa-th-large"></i> Grid
                  </button>
                  <button
                    className={`legal-toggle-btn ${viewMode === "list" ? "active" : ""}`}
                    onClick={() => setViewMode("list")}
                  >
                    <i className="fas fa-list"></i> List
                  </button>
                </div>
              </div>

              {/* GRID VIEW */}
              {viewMode === "grid" && (
                <div className="legal-grid">
                  {legalDocs.map((doc, index) => {
                    const fileUrl = getFileUrl(doc.documentFile);
                    const docIsImage = isImage(doc.documentFile);

                    return (
                      <div
                        className="legal-card"
                        key={doc.id || index}
                        onClick={() => handleCardClick(doc)}
                      >
                        {/* TOP */}
                        <div className={getCardTopClass(doc.documentFile)}>
                          {docIsImage ? (
                            <img
                              src={fileUrl}
                              alt={doc.name}
                              className="legal-doc-preview-img"
                            />
                          ) : (
                            <div className={`legal-icon-wrap ${getIconClass(doc.documentFile)}`}>
                              <i className={`fas ${getFileIcon(doc.documentFile)}`}></i>
                            </div>
                          )}
                          <span className="legal-type-badge">
                            {doc.documentType || "Document"}
                          </span>
                        </div>

                        {/* BODY */}
                        <div className="legal-card-body">
                          <h3 className="legal-doc-name">{doc.name}</h3>

                          {doc.documentType && (
                            <span className="legal-card-category">
                              {doc.documentType}
                            </span>
                          )}

                          <button className="legal-btn-view">
                            <i className="fas fa-eye"></i> View Document
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* LIST VIEW */}
              {viewMode === "list" && (
                <div className="legal-list">
                  {legalDocs.map((doc, index) => (
                    <div
                      className="legal-list-row"
                      key={doc.id || index}
                      onClick={() => handleCardClick(doc)}
                    >
                      <div className={`legal-list-icon ${getIconClass(doc.documentFile)}`}>
                        <i className={`fas ${getFileIcon(doc.documentFile)}`}></i>
                      </div>
                      <div className="legal-list-info">
                        <div className="legal-list-name">{doc.name}</div>
                        <div className="legal-list-sub">
                          {doc.documentType || "Document"}
                        </div>
                      </div>
                      <span className="legal-list-badge">
                        {doc.documentType || "Doc"}
                      </span>
                      <i className="fas fa-chevron-right legal-list-arrow"></i>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </section>

      {/* DOCUMENT VIEWER MODAL */}
      {selectedDoc && (
        <div
          className="legal-viewer-overlay"
          onClick={() => setSelectedDoc(null)}
        >
          <div
            className="legal-viewer-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close */}
            <button
              className="legal-viewer-close"
              onClick={() => setSelectedDoc(null)}
              type="button"
              aria-label="Close"
            >
              &times;
            </button>

            {/* Header */}
            <div className="legal-viewer-header">
              <span className="legal-viewer-badge">{selectedDoc.type}</span>
              <h3 className="legal-viewer-title">{selectedDoc.name}</h3>
            </div>

            {/* Toolbar */}
            <div className="legal-viewer-toolbar">
              <a
                className="legal-toolbar-btn"
                href={selectedDoc.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-external-link-alt"></i> Open in Tab
              </a>
            </div>

            {/* Content */}
            <div className="legal-viewer-content">
              {selectedDoc.isPdf ? (
                <iframe
                  src={`https://docs.google.com/viewer?url=${encodeURIComponent(selectedDoc.url)}&embedded=true`}
                  title={selectedDoc.name}
                  className="legal-viewer-frame"
                />
              ) : selectedDoc.isImage ? (
                <div className="legal-viewer-img-wrap">
                  <img
                    src={selectedDoc.url}
                    alt={selectedDoc.name}
                    className="legal-viewer-image"
                  />
                </div>
              ) : (
                <div className="legal-viewer-unsupported">
                  <i className="fas fa-file-alt"></i>
                  <p>Preview not available for this file type.</p>
                  <a
                    href={selectedDoc.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="legal-open-link"
                  >
                    <i className="fas fa-external-link-alt"></i>
                    Open File
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* FOOTER */}
      <Footer/>
    </div>
  );
};

export default LegalDocumentsPage;